export default __webpack_public_path__ + "media/images/icons/map-marker-alt-solid-d9fe5579ce7cf80dff9dec10233e4dcf.svg";